import React from "react";

export default function CouponScopeFields({ form, books, updateField }) {
  return <>
    <label htmlFor="coupon-book">Book</label>
    <select id="coupon-book" value={form.target_book_title} onChange={event => updateField("target_book_title", event.target.value)}>
      <option value="">All books</option>
      {books.map(book => <option key={book.title} value={book.title}>{book.title}</option>)}
      {form.target_book_title && !books.some(book => book.title === form.target_book_title) &&
        <option value={form.target_book_title}>Unavailable: {form.target_book_title}</option>}
    </select>
    <label htmlFor="coupon-format">Edition</label>
    <select id="coupon-format" value={form.discount_type === "free_ebook" ? "ebook" : form.target_format} disabled={form.discount_type === "free_ebook"}
      onChange={event => updateField("target_format", event.target.value)}>
      <option value="">All editions</option>
      <option value="ebook">Ebook</option>
      <option value="paperback">Paperback</option>
      <option value="hardcover">Hardcover</option>
      <option value="audiobook">Audiobook</option>
    </select>
    <label htmlFor="coupon-max-uses">Maximum uses</label>
    <input id="coupon-max-uses" type="number" min="1" step="1" placeholder="Unlimited" value={form.max_uses}
      onChange={event => updateField("max_uses", event.target.value)} />
  </>;
}
